import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import styles from "./styles.module.scss";
import Input from "../../../custom/input/input";
import Checkbox from "../../../custom/checkbox/checkbox";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getTopManagement, updateTopManagement } from "../../../requests";
import { useAtomValue } from "jotai";
import { isUpdateCorporateProfile, userProfile } from "../../../state";
import { App, Spin } from "antd";
import { AxiosError } from "axios";
import Button from "../../../custom/button/button";
import { errorMessage } from "../../../utils/errorMessage";

const TopManagement = () => {
  const { notification } = App.useApp();
  const profile = useAtomValue(userProfile);
  const isProfileEditable = useAtomValue(isUpdateCorporateProfile);

  const updateTopManagementMutation = useMutation({mutationFn: updateTopManagement})
  const { data, isPending, isError, error, refetch } = useQuery({
    queryKey: ["top-management"],
    queryFn: () => getTopManagement(profile?.MembershipNo!),
  });

  const management = data?.Data as TopManagement;

  const handleUpdate = async (values: FormikValues) => {
    const payload: Partial<TopManagement> = {
      Id: management.Id || 0,
      MembershipNo: profile?.MembershipNo,
      DirectorName: values?.ceoName || management?.DirectorName,
      DirectorEmail: values?.ceoEmail || management?.DirectorEmail,
      Telephone: values?.phoneNumber || management?.Telephone,
      MobilePhone: values?.mobileNumber || management?.MobilePhone,
      RepName: profile?.Name,
      RepDesignation: values?.designation || management?.RepDesignation || ""
    }
    try {
      await updateTopManagementMutation.mutateAsync(payload, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.Message || "Top Management updated successfully",
          });
          refetch();
        }
      })
    }
    catch(error: any) {
      notification.error({
        message: "Error",
        description: errorMessage(error)
      })
    }
  }

  const formik = useFormik<FormikValues>({
    initialValues: {
      ceoName: management?.DirectorName,
      ceoEmail: management?.DirectorEmail,
      phoneNumber: management?.Telephone,
      mobileNumber: management?.MobilePhone,
      verifyInfo: "no",
      name: profile?.Name,
      designation: management?.RepDesignation,
    },
    onSubmit: (values) => {
      handleUpdate(values);
    },
    enableReinitialize: true,
  });

  if (isPending)
    return <Spin style={{ justifySelf: "center", alignSelf: "center" }} />;
  if (isError) return <div>{(error as AxiosError)?.message}</div>;

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit} className={styles.form}>
        <Field
          name="ceoName"
          as={Input}
          label="Name of Chief Executive / Director"
          placeholder="Kaima Technologies"
          disabled={!isProfileEditable}
        />
        <Field
          name="ceoEmail"
          as={Input}
          label="Email of Chief Executive / Director"
          placeholder="Kaima Technologies"
          disabled={!isProfileEditable}
        />
        <div className={styles.fields}>
          <Field name="phoneNumber" as={Input} label="Phone Number" disabled={!isProfileEditable} />
          <Field name="mobileNumber" as={Input} label="Mobile Number" disabled={!isProfileEditable} />
        </div>
        <hr className={styles.hr} />
        <div className={styles.checkboxWrapper}>
          <Field
            name="verifyInfo"
            as={Checkbox}
            value="yes"
            label="Declaration: I hereby declare that the information provided above are correct"
            disabled={!isProfileEditable}
          />
        </div>
        <Field name="name" as={Input} label="Name" disabled />
        <Field name="designation" as={Input} label="Designation" disabled={!isProfileEditable} />
        <br/>
        {isProfileEditable && (
          <div className={styles.btnWrapper}>
          <Button type="submit" isLoading={updateTopManagementMutation.isPending} disabled={updateTopManagementMutation.isPending} text="Save Changes"/>
          </div>
        )}
      </form>
    </FormikProvider>
  );
};

export default TopManagement;
